import { memo } from 'react';

function CaretUpFilled({ fill = '#607EFE' }: { fill?: string }) {
	return (
		<svg
			width="11"
			height="7"
			viewBox="0 0 11 7"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.51348 0.531249L0.410186 6.25691L10.6168 6.25691L5.51348 0.531249Z"
				fill={fill}
			/>
		</svg>
	);
}

export default memo(CaretUpFilled);
